/**
 * Debt Requests Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageDebtSendingSchedulesComponent,
  AsyncAddDebtSendingSchedulesComponent,
  AsyncModifyDebtSendingSchedulesComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageDebtSendingSchedulesComponent}
      />
      <Route
        path={`${match.url}/create`}
        component={AsyncAddDebtSendingSchedulesComponent}
      />
      <Route
        path={`${match.url}/modify`}
        component={AsyncModifyDebtSendingSchedulesComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
